/* BaseActivityViewColumnComponent.js */

"use strict";

const DefaultColumnComponent = require("@gluenetworks/steve_ui_widgets").GridGl
    .DefaultColumnComponent;
const _ = require("lodash");

const ActivityMap = {
    DRAFT: {
        VALIDATING: {
            status: "running",
            type: "note",
            msg: "Plan validation started",
            includeUser: true,
        },
    },
    VALIDATING: {
        VALIDATED: {
            status: "success",
            type: "system",
            msg: "The plan was successfully validated",
        },
        INVALID: {
            status: "failed",
            type: "system",
            msg: "The plan did not pass validation",
        },
        VALIDATION_ERROR: {
            status: "error",
            type: "system",
            msg: "An error occurred while running plan validation",
        },
        VALIDATION_CANCELED: {
            status: "failed",
            type: "note",
            msg: "The plan validation was canceled",
            includeUser: true,
        },
    },
    VALIDATED: {
        RUNNING: {
            status: "running",
            type: "note",
            msg: "The plan was started",
            includeUser: true,
        },
        SCHEDULED: {
            status: "clean",
            type: "note",
            msg: "The plan was scheduled to run in the future",
        },
    },
    BUNDLING: {
        BUNDLED: {
            status: "success",
            type: "system",
            msg: "The plan was bundled successfully",
        },
        BUNDLE_ERROR: {
            status: "error",
            type: "system",
            msg: "An error occurred while bundling the plan",
        },
    },
    BUNDLED: {
        UPLOADING_RESULTS: {
            status: "running",
            type: "note",
            msg: "The plan results are being uploaded",
        },
    },
    UPLOADING_RESULTS: {
        UPGRADE_COMPLETE: {
            status: "success",
            type: "system",
            msg: "The plan results were uploaded successfully",
        },
        UPGRADE_INCOMPLETE: {
            status: "queued",
            type: "system",
            msg: "The plan results upload was not complete",
        },
        UPGRADE_ERROR: {
            status: "error",
            type: "system",
            msg: "An error occurred while uploading the plan results",
        },
    },
    UPGRADE_COMPLETE: {
        UPLOADING_RESULTS: {
            status: "running",
            type: "note",
            msg: "The plan results are being uploaded",
        },
    },
    SCHEDULED: {
        RUNNING: {
            status: "running",
            type: "system",
            msg: "The plan was started by a schedule",
        },
    },
    RUNNING: {
        COMPLETE: {
            status: "success",
            type: "system",
            msg: "The plan completed successfully",
        },
        CANCELED: {
            status: "failed",
            type: "note",
            msg: "The plan was canceled",
            includeUser: true,
        },
        ERROR: {
            status: "failed",
            type: "system",
            msg: "An error occurred while running the plan",
        },
    },
};

class BaseActivityViewColumnComponent extends DefaultColumnComponent {
    constructor(activityEntity) {
        super(activityEntity);
        this._registerListeners();
    }

    /*******************************************/
    /* START PRIVATE COMPONENT MODEL METHODS   */
    /*******************************************/

    _registerListeners() {}

    _unregisterListeners() {}

    /*******************************************/
    /* END PRIVATE COMPONENT MODEL METHODS     */
    /* START PUBLIC COMPONENT MODEL METHODS    */
    /*******************************************/

    shutdown() {
        this._unregisterListeners();
    }

    /*******************************************/
    /* END COMPONENT MODEL METHODS             */
    /* START HANDLER METHODS                   */
    /*******************************************/

    /*******************************************/
    /* END HANDLER METHODS                     */
    /* START PRIVATE METHODS                   */
    /*******************************************/

    /*******************************************/
    /* END PRIVATE METHODS                     */
    /* START PUBLIC API METHODS                */
    /*******************************************/

    _normalizeCreateActivity(activityEntity) {
        let activity = {};
        _.set(activity, "activityType.activityType", "note");
        _.set(
            activity,
            "description.description",
            `Plan created by user (${activityEntity.createdBy}).`
        );
        _.set(activity, "status", "clean");
        return activity;
    }

    _normalizeUpdateActivity(activityEntity) {
        let before = activityEntity.before;
        let patch = activityEntity.patch;
        if (_.isEmpty(before) || _.isEmpty(patch)) {
            return;
        }
        let updatedBy =
            _.get(_.find(patch, {path: "/updatedBy"}), "value") || before.updatedBy || "system";
        let oldStatus = before.status;
        let newStatus = _.get(_.find(patch, {path: "/status"}), "value");
        let activityValues = _.get(ActivityMap, [oldStatus, newStatus]);
        if (activityValues) {
            let activity = {};
            _.set(activity, "activityType.activityType", activityValues.type);
            let description = activityValues.msg;
            if (activityValues.includeUser && updatedBy) {
                description += ` (${updatedBy})`;
            }
            _.set(activity, "description.description", description);

            _.set(activity, "status", activityValues.status);
            return activity;
        } else {
            let activity = {};
            _.set(activity, "activityType.activityType", "note");
            _.set(activity, "description.description", `Plan updated by user (${updatedBy})`);
            _.set(activity, "status", "clean");
            return activity;
        }
    }

    _normalizeActivity(activityEntity) {
        let activity;
        let activityType = activityEntity.activityType;
        switch (activityType) {
            case "create":
                activity = this._normalizeCreateActivity(activityEntity);
                break;
            case "update":
                activity = this._normalizeUpdateActivity(activityEntity);
                break;
        }
        if (!_.isEmpty(activity)) {
            let date =
                new Date(activityEntity.createdOn).toLocaleDateString() +
                " " +
                new Date(activityEntity.createdOn).toLocaleTimeString();

            _.set(activity, "snapshot.snapshot", date);
            _.set(activity, "id", activityEntity.id);
        }

        return activity;
    }

    /*******************************************/
    /* END PUBLIC API METHODS                  */
    /*******************************************/
}

module.exports = BaseActivityViewColumnComponent;
